import { createStore, combineReducers } from 'redux'
import { configure } from '../api'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import { departureDate } from '../actions/dive-operator-actions'
import {
  selectedCurrency,
  setCurrency,
  pageLoader,
  itineraryPopupOpen,
  itineraryPopupData,
} from '../actions/main-actions'
import {
  currencyDirective,
  collapseItems,
  openToggler,
  abTest,
} from '../directives'
import 'babel-polyfill'
import 'whatwg-fetch'
import { getLanguage, checkIsEditOrder, getTranslations } from 'utils'

import { LiveaboardPricing } from '../components'
import HeroLightbox from '../components/liveaboard/HeroLightbox'
import OtherDiveOperators from '../components/liveaboard/OtherDiveOperators'
import Reviews from '../components/operator/Reviews'
import DeckPlans from '../components/liveaboard/DeckPlans'
import PriceConverter from '../components/helpers/PriceConverter'
import WasThisHelpful from '../components/operator/WasThisHelpful'
import ErrorHandler from '../components/ErrorHandler'
import RoomCard from '../components/resort/RoomCard'
import CustomPopup from '../components/popups/CustomPopup'
import '@formatjs/intl-getcanonicallocales/polyfill'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import 'finally-polyfill'
import { createRoot } from 'react-dom/client'

if(process.env.SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    ignoreErrors: [
      'AbortError',
      'UnhandledRejection',
      'Unexpected token o in JSON at position 1',
      'Anonymous function(/gtm.js)',
      "undefined is not an object (evaluating 'd.appendChild')",
      'chrome-extension',
      'gtm',
      'Illegal invocation',
      "Can't find variable: setIOSParameters",
      '(app-modern)',
      'd is undefined',
    ],
  })
}

checkIsEditOrder()

let store = createStore(
  combineReducers({
    pageLoader,
    selectedCurrency,
    departureDate,
    itineraryPopupOpen,
    itineraryPopupData,
  }),
)

let language = getLanguage()
let messages = {}

window.store = store
configure(store)

// window.fx = fx

if(language !== 'en') {
  getTranslations(language, renderApp)
} else {
  renderApp()
}

function renderApp(translatedStrings) {
  if(translatedStrings) {
    messages = translatedStrings
  }
  // renderElement('group-trip-itineraries', GroupTripItineraries, {
  //   ...window.shop,
  //   marketPlaceSlug: window.marketPlace.slug,
  // })
  // renderElement('virtual-tour-popup', VirtualTourPopup, {
  //   virtualTourLink: window.virtualTourLink,
  // })
  // renderElement('travel_resources-answer', WasThisHelpful, {
  //   type: 'travelResources',
  //   shopSlug: window.shop.slug,
  // })

  renderElement('la-pricing-table', LiveaboardPricing, window.shop)
  renderElement('hero-lightbox', HeroLightbox, {
    photos: window.photos,
    videos: window.videos,
  })
  renderElement('highlights-answer', WasThisHelpful, {
    type: 'Highlights',
    shopSlug: window.shop.slug,
  })
  renderElement('other-diveoperators', OtherDiveOperators, {
    eCommerceListName: 'Travel Vacations - Liveaboard Page - Other Operators',
    padiCheckoutName: 'PADI Travel - Liveaboards',
  })
  renderElement('cabins-list', RoomCard, { rooms: window.cabinsList })
  renderElement('reviews', Reviews, window.shop)
  renderElement('deck-plans', DeckPlans, { deckPlans: window.deckPlans })

  renderElement('minimum-price', PriceConverter, {
    amount: +window.shop.minimumPrice,
    currency: 'USD',
  })

  if(window.popup && window.popup.showPopup) {
    renderElement('custom_popup', CustomPopup, {
      message: window.popup.popupContent,
    })
  }

  currencyDirective(function(currency) {
    store.dispatch(setCurrency(currency))
  })
  openToggler()
  collapseItems()
  abTest(process.env.GOOGLE_EXPERIMENT_ID_LA)
}

function renderElement(elem, ComponentToRender, props) {
  let element
  if(typeof elem === 'string') {
    element = document.getElementById(elem)
  } else {
    element = elem
  }

  if(element) {
    const root = createRoot(element)
    root.render(
      <IntlProvider
        locale={language === 'ach' ? 'en' : language}
        messages={messages}
        textComponent='span'
      >
        <Provider store={store}>
          <ErrorHandler>
            <ComponentToRender {...props} />
          </ErrorHandler>
        </Provider>
      </IntlProvider>,
    )
  }
}
